import { Injectable, NgZone } from '@angular/core'
import { Router } from '@angular/router'
import * as Sentry from '@sentry/angular'
import { StateService } from './services/state.service'
import { LogService } from 'htv-lib'

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler extends Sentry.SentryErrorHandler {
  constructor(
    private router: Router,
    private logService: LogService,
    private stateService: StateService,
    private zone: NgZone
  ) {
    super({ logErrors: true })
  }

  override handleError(error: any): void {
    let showErrorPage = true

    const err = error?.rejection ?? error

    // DOMException: The play() request was interrupted by a new load request.
    // Happens when a video (vod) does not load and we exit the page
    if (err instanceof DOMException && err.name === 'AbortError') {
      this.logService.error(`[GlobalErrorHandler] AbortError caught: ${err.message}`)
      showErrorPage = false
    }

    // RangeError: Array buffer allocation failed
    // Happens when Shaka player loads too much in memory
    if (err instanceof RangeError) {
      this.logService.error(`[GlobalErrorHandler] RangeError caught: ${err.message}`)
      showErrorPage = false
    }

    if (showErrorPage) {
      this.zone.run(() => {
        this.router.navigate(['/error'])
      })
    }

    // Mark error state (for loading page)
    this.stateService.error$.next(error)

    // Call Sentry's error handler to capture errors
    super.handleError(error)
  }
}
